import React from 'react';
export function StatsBar() {
  return <div className="border-y border-zinc-800 bg-surface/50 py-6" data-id="element-249">
      <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center md:justify-between gap-6 md:gap-4 text-center md:text-left" data-id="element-250">
        <div className="w-[45%] md:w-auto" data-id="element-251">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-252">
            +500
          </div>
          <div className="text-zinc-400 text-sm" data-id="element-253">profes confían</div>
        </div>
        <div className="w-[45%] md:w-auto" data-id="element-254">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-255">
            6 Tomos
          </div>
          <div className="text-zinc-400 text-sm" data-id="element-256">listos para usar</div>
        </div>
        <div className="w-[45%] md:w-auto" data-id="element-257">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-258">
            6 Bonos
          </div>
          <div className="text-zinc-400 text-sm" data-id="element-259">incluidos gratis</div>
        </div>
        <div className="w-[45%] md:w-auto" data-id="element-260">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-261">
            4.9/5
          </div>
          <div className="text-yellow-400 text-sm" data-id="element-262">⭐⭐⭐⭐⭐</div>
        </div>
      </div>
    </div>;
}